import { TranslateModule } from '@ngx-translate/core';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScoreInfoComponent } from './score-info.component';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [ScoreInfoComponent],
  declarations: [ScoreInfoComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ScoreInfoComponentModule {}
